<template>
  <div>
    {{ content }}
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'order-list-item-after',
  dependencies: ['diningPreferenceType'],
  props: {
    order: Object
  },
  methods: {
    formatPickupTime: function (dateString) {
      const startOfToday = moment().startOf('day')
      const startOfTomorrow = startOfToday.clone().add(1, 'day')
      const endOfTomorrow = startOfTomorrow.clone().endOf('day')
      const date = moment(dateString)

      if (date.isBetween(startOfToday, startOfTomorrow)) {
        return '今天 ' + date.format('HH:mm')
      } else if (date.isBetween(startOfTomorrow, endOfTomorrow)) {
        return '明天 ' + date.format('HH:mm')
      }

      return date.format('M/D HH:mm')
    }
  },
  computed: {
    content () {
      switch (this.order.diningPreference) {
        case this.diningPreferenceType.forHere:
          return this.order.tableNumber
        case this.diningPreferenceType.takeAway:
          return '外帶'
        case this.diningPreferenceType.preOrder:
          return this.formatPickupTime(this.order.pickupTime)
        default:
          return '外帶'
      }
    }
  }
}
</script>
